module.exports = __webpack_public_path__ + "resources/img/main02_gov_m.fba5daca99c8e51094a69aebc6b1f867.jpg";